import {AuthService} from 'app/components/sign/auth.service';
import {FormError} from 'app/model/FormError';
import {ERROR_CONTENT} from 'app/components/sign/form/errorsData';
import {find} from 'lodash';

export const useSocialLogin = (formType, errors$, registration, forwardReferer) => {
    if (!['login', 'register'].includes(formType)) {
        throw new TypeError('Form Type have to be login or register');
    }
    const auth = new AuthService();

    const handleFailure = (err) => {
        if (err && !err.response && err.includes('Failed to load SDK')) {
            console.error('Invalid origin for the SDK.'); //eslint-disable-line
            return;
        }

        if (err && err.response && err.response.data && err.response.data.errors) {
            const errors = err.response.data.errors;
            const socialUserExists = find(errors, {code: 'social_email_already_taken'});

            if (socialUserExists) {
                return errors$.next([
                    new FormError({
                        type: 'global',
                        content: ERROR_CONTENT['social_email_already_taken']
                    })
                ]);
            }
        }

        errors$.next([
            new FormError({
                type: 'global',
                content: ERROR_CONTENT[`${formType}_attempt_error`]
            })
        ]);
    };

    const handleSuccess = (serviceName, newsletter=false) => ({token, extras}) => {
        const {accessToken, idToken} = token;
        let firstName = null;
        let lastName = null;

        if (extras !== undefined) {
            firstName = extras.firstName ? extras.firstName : null;
            lastName = extras.lastName ? extras.lastName : null;
        }

        auth.signInSocial(serviceName, accessToken, idToken, registration, forwardReferer, newsletter, firstName, lastName)
            .then(() => errors$.next([]))
            .catch(handleFailure);
    };

    return [handleSuccess, handleFailure];
};
